import { render, staticRenderFns } from "./projectLayout.vue?vue&type=template&id=42de4af3&scoped=true"
import script from "./projectLayout.vue?vue&type=script&lang=js"
export * from "./projectLayout.vue?vue&type=script&lang=js"
import style0 from "./projectLayout.vue?vue&type=style&index=0&id=42de4af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de4af3",
  null
  
)

export default component.exports